import type { ReactNode } from 'react';

/**
 * Empty / loading state placeholders. The 7+ pages that hand-roll
 * "<div className='text-center py-8 text-slate-400'>暂无记录</div>" can
 * use this instead — gives consistent vertical spacing + lets us add
 * illustrations later in one place.
 */

interface EmptyStateProps {
  title: string;
  hint?: string;
  icon?: string;
  /** Lighter vertical padding for inline use inside tables / small cards. */
  compact?: boolean;
}

export function EmptyState({
  title,
  hint,
  icon,
  compact = false,
}: EmptyStateProps): JSX.Element {
  return (
    <div
      className={`text-center text-slate-500 ${
        compact ? 'py-6' : 'py-12'
      }`}
    >
      {icon !== undefined && <div className="text-3xl mb-2 opacity-60">{icon}</div>}
      <p className="text-sm">{title}</p>
      {hint !== undefined && <p className="text-xs mt-1 text-slate-600">{hint}</p>}
    </div>
  );
}

interface LoadingStateProps {
  hint?: string;
  compact?: boolean;
}

/**
 * Boot/refresh loading placeholder. Distinct from EmptyState so we can
 * style differently later (spinner, skeleton, etc) without touching call
 * sites.
 */
export function LoadingState({
  hint = '加载中…',
  compact = false,
}: LoadingStateProps): ReactNode {
  return (
    <div
      className={`text-center text-slate-400 ${
        compact ? 'py-6' : 'py-12'
      }`}
    >
      <div className="inline-block animate-pulse text-sm">{hint}</div>
    </div>
  );
}
